export default {
  async created() {
    this.$store.commit("setFixedFooterState", true)
  },
  beforeDestroy() {
    this.$store.commit("setFixedFooterState", false)
  }
}
